// "View as" preview state — admin-only.
//
// Kept deliberately in-memory (not localStorage) so a full page reload always
// clears it and returns the admin to their real role. That makes it impossible
// to get permanently stuck in a previewed role. useApi reads this on every
// request and forwards it as the X-View-As header; the backend only honors it
// for users whose real role is admin.

export type PreviewRole = 'tech' | 'user' | 'viewer';

let _viewAs: PreviewRole | null = null;

export function getViewAs(): PreviewRole | null {
  return _viewAs;
}

export function setViewAs(role: PreviewRole | null): void {
  _viewAs = role;
}
